import React, { useEffect} from "react";
import { createLanguage } from "adminApi/LanguageApi/Language";
import { validateForm } from "utils/validation";
import { LanguageRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import LanguageForm from "./Componates/LanguageForm";
import fields from "../json/LanguageFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddLanguge = ({setLanguage, canShowAction}) => {
  const { formdata } = fields;       

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange } = useFormChange(initialValues, LanguageRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit,refatch } = useFormSubmit(
    async (formValues) => {
      if (!canShowAction) {
        return;
      }
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await createLanguage({data: formData });
    },
    (vals) => validateForm(vals, LanguageRules),
    () => {},
    "Language Created successfully"
  );
  useEffect(() => {
    setLanguage(refatch);
    values['language']="";
  }, [refatch]);

  return (
    <>
      {( loadingSubmit) && <Spinner isSpinner={true} />}
      <LanguageForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Language"
      />
    </>
  );
};

export default AddLanguge;
